const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/content/categories/$id.add-from-catalog.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { type AddFromCatalogSearch, addFromCatalogSearchSchema } from '@/Components/addFromCatalog';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/dash/content/categories/$id/add-from-catalog')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: (search): AddFromCatalogSearch => addFromCatalogSearchSchema.parse(search),
  beforeLoad: ({
    params,
    search
  }) => {
    if (!params.id || !search.afcType) {
      throw redirect({
        to: '/dash/content/categories'
      });
    }
  }
});